import Pikaday from 'pikaday';

export default class BigOrder {
    constructor() {
      const calendarBtn = document.querySelector('section.order form input#bo_date');
      if (calendarBtn) {
        new Pikaday({
          field: calendarBtn,
          firstDay: 1,
          format: 'DD / MM / YYYY',
          i18n: {
            "prev": "Précédent",
            "next": "Suivant",
            "previousMonth": "",
            "nextMonth": "",
            "months": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
            "weekdays": ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            "weekdaysShort": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"]
          },
        });
      }
    }
}